import { http_v2 } from '@api/client';
import { paramterize, pickResponse } from '@api/utils';
import { DealFilterParams, FilterResponse } from './types';

/**
 * Filter deals using dynamic operators.
 * @param option Query options
 */
export function filter({
  filters = [],
  pageSize: page_size = 10,
  page = 1,
  sortBy = [],
}: DealFilterParams = {}) {
  const isBuyersSort = (key: string) => ['buyers'].includes(key);
  const isSellersSort = (key: string) => ['sellers'].includes(key);
  const isContentSort = (key: string) => ['contents'].includes(key);
  const isToAirOnSort = (key: string) => ['to_air_on'].includes(key);

  const sort_buyers = sortBy
    .filter(({ id }) => isBuyersSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort_sellers = sortBy
    .filter(({ id }) => isSellersSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort_contents = sortBy
    .filter(({ id }) => isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort_to_air_on = sortBy
    .filter(({ id }) => isToAirOnSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort = sortBy
    // .filter(({ id }) => !isBuyersSort(id) && !isSellersSort(id) && !isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');
  const newFilters = filters; //updateFiltersForLinkedOperator(filters);
  const resolveId = (id: string) => {
    return { buyers: 'buyer', sellers: 'seller', contents: 'content', to_air_on: 'to_air_on', updated_at_filter: 'updated_at' }[id] || id;
  };
  const filtersMap: Record<string, string> = newFilters.reduce(
    (map, f) =>
      Object.assign(map, {
        [resolveId(f.id)]: Object.entries(f.value)
          .map(([op, v]) => (
            op === '$bw' ? `$gte|||${v[0]};$lte|||${v[1]}` : `${op}|||${v.trim()}`)
            )
          .join(';'),
      }),
    {}
  );

  const params = paramterize({
    page_size,
    page,
    sort,
    // sort_buyers,
    // sort_sellers,
    // sort_contents,
    ...filtersMap,
  });

  return http_v2.get<FilterResponse>('/deals', { params }).pipe(pickResponse());
}

function updateFiltersForLinkedOperator(filters) {
  let newFilters = JSON.parse(JSON.stringify(filters));
  const mappedDataForLinkedOperator = [];

  newFilters.forEach(eachfilter => {
    const mappedValuesForLinkedOperator = {};
    Object.entries(eachfilter.value).forEach(eachIdOperators => {
      if (eachIdOperators.includes('$linked')) {
        eachIdOperators[0] = '$empty';
        eachIdOperators[1] === 'yes'
          ? (eachIdOperators[1] = 'false')
          : (eachIdOperators[1] = 'true');
        mappedValuesForLinkedOperator[eachIdOperators[0]] = eachIdOperators[1];
        mappedDataForLinkedOperator.push({
          id:
            eachfilter.id === 'entity1'
              ? 'entity1_vtr_id'
              : eachfilter.id === 'entity2'
              ? 'entity2_vtr_id'
              : eachfilter.id === 'content'
              ? 'content_vtr_id'
              : eachfilter.id,
          value: mappedValuesForLinkedOperator,
        });
      }
    });
    if (Object.keys(mappedValuesForLinkedOperator).length) {
      delete eachfilter['value']['$linked'];
    }
  });
  newFilters = [...newFilters, ...mappedDataForLinkedOperator];
  return newFilters;
}
